// export function Footer() {
//   return (
//     <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
//         {/* Logo & Short Description */}
//         <div>
//           <h2 className="text-2xl font-bold text-white mb-4">
//             TechFix Computers
//           </h2>
//           <p className="text-gray-400">
//             Providing reliable computer products, expert repairs, and excellent
//             customer service for over 10 years.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
//           <ul className="space-y-2">
//             <li>
//               <a href="#home" className="hover:text-blue-500 transition-colors">
//                 Home
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#services"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Services
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Products
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#about"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 About
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#contact"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Contact
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Products / Shop */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Shop</h3>
//           <ul className="space-y-2">
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Laptops
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Keyboards
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Mice & Accessories
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Monitors
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Contact Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
//           <ul className="space-y-2">
//             <li>Kampala, Uganda</li>
//             <li>+256 700 123 456</li>
//             <li>info@techfix.com</li>
//           </ul>
//           <div className="flex space-x-4 mt-4">
//             <a
//               href="#"
//               className="text-gray-400 hover:text-blue-500 transition-colors"
//             >
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M22 12C22 6.477 17.523 2 12 2S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.988H7.898v-2.89h2.54v-2.205c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.878h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
//               </svg>
//             </a>
//             <a
//               href="#"
//               className="text-gray-400 hover:text-blue-500 transition-colors"
//             >
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M8.29 20c7.547 0 11.675-6.155 11.675-11.495 0-.175 0-.349-.012-.522A8.18 8.18 0 0 0 22 5.92a8.273 8.273 0 0 1-2.357.636 4.118 4.118 0 0 0 1.804-2.27 8.224 8.224 0 0 1-2.605.988 4.107 4.107 0 0 0-6.993 3.743 11.65 11.65 0 0 1-8.457-4.287 4.106 4.106 0 0 0 1.27 5.482A4.073 4.073 0 0 1 2 9.713v.051a4.105 4.105 0 0 0 3.292 4.022 4.095 4.095 0 0 1-1.852.07 4.108 4.108 0 0 0 3.834 2.848A8.233 8.233 0 0 1 2 18.407a11.616 11.616 0 0 0 6.29 1.84" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Bottom copyright */}
//       <div className="mt-12 border-t border-gray-800 pt-6 text-center text-gray-500 text-sm">
//         &copy; {new Date().getFullYear()} TechFix Computers. All rights
//         reserved.
//       </div>
//     </footer>
//   );
// }

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Company Info */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">
            Kevmark Investments Limited
          </h2>
          <p className="text-gray-400">
            Delivering IT solutions, stationery, branding, and printing services
            in Uganda since 2008.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="#home" className="hover:text-blue-500 transition-colors">
                Home
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="hover:text-blue-500 transition-colors"
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#products"
                className="hover:text-blue-500 transition-colors"
              >
                Products
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="hover:text-blue-500 transition-colors"
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="hover:text-blue-500 transition-colors"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Shop */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Shop</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="#products"
                className="hover:text-blue-500 transition-colors"
              >
                Laptops
              </a>
            </li>
            <li>
              <a
                href="#products"
                className="hover:text-blue-500 transition-colors"
              >
                Keyboards
              </a>
            </li>
            <li>
              <a
                href="#products"
                className="hover:text-blue-500 transition-colors"
              >
                Mice & Accessories
              </a>
            </li>
            <li>
              <a
                href="#products"
                className="hover:text-blue-500 transition-colors"
              >
                Monitors
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
          <ul className="space-y-2 text-gray-400">
            <li>Kampala, Uganda</li>
            <li>+256 772 551 508 | +256 752 551 508</li>
            <li>+256 414 232 531</li>
            <li>
              <a
                href="mailto:Kevmarksales@gmail.com"
                className="hover:text-blue-500 transition-colors"
              >
                sales@kevmarkinvestments.com
              </a>
            </li>
            <li>
              <a
                href="mailto:nakyarzinta@yahoo.com"
                className="hover:text-blue-500 transition-colors"
              >
                md@kevmarkinvestments.com
              </a>
            </li>
            <li>
              <a
                href="https://www.kevmarkinvestments.com"
                className="hover:text-blue-500 transition-colors"
              >
                www.kevmarkinvestments.com
              </a>
            </li>
          </ul>
          <div className="flex space-x-4 mt-4">
            <a
              href="#"
              className="text-gray-400 hover:text-blue-500 transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12C22 6.477 17.523 2 12 2S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.988H7.898v-2.89h2.54v-2.205c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.878h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a
              href="#"
              className="text-gray-400 hover:text-blue-500 transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20c7.547 0 11.675-6.155 11.675-11.495 0-.175 0-.349-.012-.522A8.18 8.18 0 0 0 22 5.92a8.273 8.273 0 0 1-2.357.636 4.118 4.118 0 0 0 1.804-2.27 8.224 8.224 0 0 1-2.605.988 4.107 4.107 0 0 0-6.993 3.743 11.65 11.65 0 0 1-8.457-4.287 4.106 4.106 0 0 0 1.27 5.482A4.073 4.073 0 0 1 2 9.713v.051a4.105 4.105 0 0 0 3.292 4.022 4.095 4.095 0 0 1-1.852.07 4.108 4.108 0 0 0 3.834 2.848A8.233 8.233 0 0 1 2 18.407a11.616 11.616 0 0 0 6.29 1.84" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="mt-12 border-t border-gray-800 pt-6 text-center text-gray-500 text-sm">
        &copy; {new Date().getFullYear()} Kevmark Investments Limited. All
        rights reserved.
      </div>
    </footer>
  );
}

// export function Footer() {
//   return (
//     <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
//         {/* Logo & Short Description */}
//         <div>
//           <h2 className="text-2xl font-bold text-white mb-4">
//             Kevmark Investments Limited
//           </h2>
//           <p className="text-gray-400">
//             Providing reliable computer products, expert repairs, and excellent
//             customer service for over 10 years.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
//           <ul className="space-y-2">
//             <li>
//               <a href="#home" className="hover:text-blue-500 transition-colors">
//                 Home
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#services"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Services
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Products
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#about"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 About
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#contact"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Contact
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Products / Shop */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Shop</h3>
//           <ul className="space-y-2">
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Laptops
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Keyboards
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Mice & Accessories
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#products"
//                 className="hover:text-blue-500 transition-colors"
//               >
//                 Monitors
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Contact Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
//           <ul className="space-y-2">
//             <li>Kampala, Uganda</li>
//             <li>+256 700 123 456</li>
//             <li>info@kevmarkinvestments.com</li>
//           </ul>
//           <div className="flex space-x-4 mt-4">
//             <a
//               href="#"
//               className="text-gray-400 hover:text-blue-500 transition-colors"
//             >
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M22 12C22 6.477 17.523 2 12 2S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.988H7.898v-2.89h2.54v-2.205c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.878h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
//               </svg>
//             </a>
//             <a
//               href="#"
//               className="text-gray-400 hover:text-blue-500 transition-colors"
//             >
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M8.29 20c7.547 0 11.675-6.155 11.675-11.495 0-.175 0-.349-.012-.522A8.18 8.18 0 0 0 22 5.92a8.273 8.273 0 0 1-2.357.636 4.118 4.118 0 0 0 1.804-2.27 8.224 8.224 0 0 1-2.605.988 4.107 4.107 0 0 0-6.993 3.743 11.65 11.65 0 0 1-8.457-4.287 4.106 4.106 0 0 0 1.27 5.482A4.073 4.073 0 0 1 2 9.713v.051a4.105 4.105 0 0 0 3.292 4.022 4.095 4.095 0 0 1-1.852.07 4.108 4.108 0 0 0 3.834 2.848A8.233 8.233 0 0 1 2 18.407a11.616 11.616 0 0 0 6.29 1.84" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Bottom copyright */}
//       <div className="mt-12 border-t border-gray-800 pt-6 text-center text-gray-500 text-sm">
//         &copy; {new Date().getFullYear()} Kevmark Investments Limited. All
//         rights reserved.
//       </div>
//     </footer>
//   );
// }
